class CustomDropdown {
  constructor(select) {
    this.select = select;
    this.wrapper = document.createElement('div');
    this.customSelect = document.createElement('div');
    this.optionsList = document.createElement('ul');
    
    this.init();
  }

  init() {
    // tekrar init koruması
    if (this.select?.dataset?.enhanced === 'true') return;
    this.select.dataset.enhanced = 'true';

  // Seçili değeri kontrol et ve varsayılan değer ata
  let selectedOption = this.select.options[this.select.selectedIndex];
    
    // Ana select elementini gizle
    this.select.style.display = 'none';
    
    // Wrapper oluştur
    this.wrapper.className = 'custom-dropdown-wrapper';
    this.select.parentNode.insertBefore(this.wrapper, this.select);
    this.wrapper.appendChild(this.select);
    
    // Custom select butonu oluştur
    this.customSelect.className = 'custom-dropdown-button';
    // Başlangıçta placeholder seçiliyse ilk uygun seçeneği göster
    if (!selectedOption || selectedOption.disabled || !selectedOption.value) {
      selectedOption = Array.from(this.select.options).find(o => !o.disabled && o.value);
    }
    this.setButtonContent(selectedOption);
    this.wrapper.appendChild(this.customSelect);
    
    // Seçenekler listesi oluştur
    this.optionsList.className = 'custom-dropdown-options';
    this.wrapper.appendChild(this.optionsList);
    
    // Seçenekleri oluştur
    Array.from(this.select.options).forEach((option, index) => {
      // İlk seçenek (placeholder) veya disabled seçenekleri atla
      if ((index === 0 && option.disabled) || (option.disabled && !option.selected)) return;
      
      const li = document.createElement('li');
      li.className = 'custom-dropdown-option';
      
      // Metin ve birim fiyatı ayrıştır
      const { mainText, unitPriceText } = this.parseOptionTexts(option);

      // Ana metin oluştur
      const displayText = document.createElement('span');
      displayText.className = 'option-text';
      displayText.textContent = mainText;
      li.appendChild(displayText);

      // Ayrı birim fiyat etiketi
      if (unitPriceText) {
        const priceInfo = document.createElement('span');
        priceInfo.className = 'option-unit-price';
        priceInfo.textContent = unitPriceText;
        li.appendChild(priceInfo);
      }
      
      li.dataset.value = option.value;
      
      // Başlangıç seçileni işaretle
      if (option.selected && !option.disabled) li.classList.add('selected');
      
      // Stok durumu
      if (option.disabled) {
        li.classList.add('soldout');
      }
      
      li.addEventListener('click', () => this.handleOptionClick(li));
      this.optionsList.appendChild(li);
    });
    
    // Event listeners ekle
    this.customSelect.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleOptions();
    });
    
    document.addEventListener('click', (e) => {
      if (!this.wrapper.contains(e.target)) {
        this.closeAllDropdowns();
      }
    });

    // Variant değişikliğini dinle
    this.select.addEventListener('change', () => {
      this.updateSelectedOption();
    });

    // İlk render sonrası seçimi senkronize et
    this.updateSelectedOption();
  }

  parseOptionTexts(option) {
    const fullText = option?.text?.trim() || option?.value || '';
    let mainText = fullText;
    let unitPriceText = null;

    // '(Birim Fiyatı ...)' formatını yakala
    const unitMatch = fullText.match(/\(\s*Birim\s*Fiyatı\s*[^\)]*\)\s*$/i);
    if (unitMatch) {
      unitPriceText = unitMatch[0].replace(/[()]/g, '').trim();
      mainText = fullText.replace(unitMatch[0], '').trim();
    } else if (option?.dataset && option.dataset.metafieldValue) {
      unitPriceText = option.dataset.metafieldValue;
    }

    return { mainText, unitPriceText };
  }

  setButtonContent(option) {
    if (!option) return;
    const { mainText, unitPriceText } = this.parseOptionTexts(option);
    this.customSelect.innerHTML = '';
    const left = document.createElement('span');
    left.className = 'option-text';
    left.textContent = mainText || 'Seçiniz';
    this.customSelect.appendChild(left);

    if (unitPriceText) {
      const right = document.createElement('span');
      right.className = 'option-unit-price';
      right.textContent = unitPriceText;
      this.customSelect.appendChild(right);
    }
  }

  updateSelectedOption() {
    const selectedOption = this.select.options[this.select.selectedIndex];
    if (selectedOption) {
      this.setButtonContent(selectedOption);
      
      // Seçili class'ı güncelle
      const options = this.optionsList.querySelectorAll('.custom-dropdown-option');
      options.forEach(opt => {
        if (opt.dataset.value === selectedOption.value) {
          opt.classList.add('selected');
        } else {
          opt.classList.remove('selected');
        }
      });
    }
  }
  
  toggleOptions() {
    const isOpen = this.optionsList.classList.contains('open');
    this.closeAllDropdowns();
    
    if (!isOpen) {
      this.optionsList.classList.add('open');
      this.customSelect.classList.add('active');
    }
  }
  
  closeAllDropdowns() {
    document.querySelectorAll('.custom-dropdown-options').forEach(list => {
      list.classList.remove('open');
    });
    document.querySelectorAll('.custom-dropdown-button').forEach(button => {
      button.classList.remove('active');
    });
  }
  
  handleOptionClick(option) {
    // Select değerini güncelle.
    this.select.value = option.dataset.value;
    
    // Change event'i tetikle
    const event = new Event('change', { bubbles: true });
    this.select.dispatchEvent(event);
    
    // Dropdown'ı kapat
    this.closeAllDropdowns();
  }
}

// Sadece data-custom-dropdown="true" olan select'leri custom dropdown'a çevir
document.addEventListener('DOMContentLoaded', () => {
  const selects = document.querySelectorAll('.select__select[data-custom-dropdown="true"]');
  selects.forEach(select => new CustomDropdown(select));
});